import _WidgetBase from 'dijit/_WidgetBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./AddressFinderHome.html');
//import "../AddressFinder/AddressFinderTypes";
import _EntityViewMixin from '../EntityBased/EntityView/EntityView';
import { EntityViewTypes } from "../EntityBased/EntityView/EntityViewTypes";


class SelectEntityDialogPreview<T> extends compose(_EntityViewMixin<any>) {
    //templateString = template; // nur falls nötig ein eigenes laden!


    setContent(content: string, entity?) {
        let data: EntityViewTypes.EntityViewResponse<T> = {
            content: content,
            entity: entity
        };
        
        this.viewData = data;
        this["_applyData"](); // ausnahmsweise auf eine interne private Funktion zugreifen
    }

    onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {
        return null;
    }

    onShow() {
        // zb weitere Buttons zum Dlg oder in den Tab einfügen...
    }

    
    onDelete() {
        
    }

    afterDelete() {

    }

    onClose() {


    }



    postCreate(): void {

        this.config = {
            entityClassname: null, // 
            labelProperty: null,
            entityClassPrintname: null
        }

        this.__isNonInteractiveEntityView = true;
        super.postCreate.apply(this, arguments as any); 

    }

    startup(): void {
        super.startup.apply(this, arguments as any);        
    }
}

export default mdsWidget(SelectEntityDialogPreview);